import * as React from 'react';
import { IPerson, IMedia, IGenre } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import { Redirect } from 'react-router';
import { transliterate } from '../utils/functions';
import { withTranslation } from 'react-i18next';
import i18n from '../config/i18next';
import AsActor from '../components/person/AsActor';
import AsDirector from '../components/person/AsDirector';
import Helmet from 'react-helmet';

interface IState {
    person: IPerson,
    isLoading: boolean,
    name: string,
    person_id: number,
    actor: number,
    director: number,
    isNotFound: boolean,
}

class PersonView extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            person: null,
            isLoading: true,
            name: this.props.match.params.name,
            person_id: this.props.match.params.person_id,
            isNotFound: false,
            actor: null,
            director: null
        };
    }

    componentWillReceiveProps(props: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        this.setState({
            name: props.match.params.name,
            person_id: props.match.params.person_id,
            isLoading: true,
        }, this.componentDidMount);
    }

    async componentDidMount() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/person/view?person_id=${this.state.person_id}`);

        if (!this._isUnmounted)
            if (response.data.status == "success") {
                this.setState({
                    person: response.data.person,
                    actor: response.data.actor,
                    director: response.data.director,
                    isLoading: false,
                });
            } else {
                this.setState({
                    isNotFound: true
                });
            }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                {this.state.isNotFound && <Redirect to="/not-found" />}
                <Helmet>
                    {!this.state.isLoading && <title>{this.state.person.full + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>}
                </Helmet>
                <div className="container c-aktyor">
                    <div className="wrapper" style={{ paddingBottom: "20px" }}>

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}

                        {!this.state.isLoading && (<div className="">
                            <div className="a-p films m-0">
                                <h1> {this.state.person.full} </h1>
                                <div className="a-f">
                                    <div className="a-l">
                                        <a href={this.state.person.fullpath} data-lightbox="image-1" data-title={this.state.person.full}>
                                            <img src={this.state.person.fullpath} />
                                        </a>
                                    </div>
                                    <div className="a-r">
                                        <p> {t("Актёр в")} {this.state.actor} {t("фильмах")} </p>
                                        <p> {t("Режиссер ")} {this.state.director} {t("фильмов")} </p>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <AsActor person_id={this.state.person_id} />
                            <AsDirector person_id={this.state.person_id} />

                        </div>)}

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(PersonView);